
import makerjs from "makerjs";
function A30(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  // console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    H = Param[0].param,R = Param[1].param,
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       r = R * 1 * myZoom,       
       h = H * 1 * myZoom,
       w = 2*r,
      hd=r-h, wd=Math.sqrt(r*r-hd*hd),wdd=r-wd,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       x0=0,y0=0,x1=2*(r-wdd),y1=0,glassH = h, glassW = w;

   if (r !== 0) {
       var TxtR = "R="+R;
   }if (h !== 0) {
    var TxtH = H;
} 
   var drawAbnormalShapeA30 = {
       paths: {
        "ArcLine": new makerjs.paths.Arc([x0,y0], [x1,y1], r, false, true),
        "BottomLine": new makerjs.paths.Line([x0,y0], [x1,y1]),
       }
   };
   var drawAbnormalShapeA30MarkR = {
       paths: {
        "LeftLine": new makerjs.paths.Line([r, -hd], [r, r-hd]),
       }
   };
   var drawAbnormalShapeA30MarkH = {
       paths: {
        "Line": new makerjs.paths.Line([0, 0], [0, h]),
        "LineUp": new makerjs.paths.Line([0-markShift, h], [0+markShift, h]),
        "LineDn": new makerjs.paths.Line([0-markShift, 0], [0+markShift, 0]),
       }
   };
   makerjs.model.addCaption(drawAbnormalShapeA30MarkR, TxtR, [r+markShift, -hd], [r+markShift, -hd]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeA30MarkH, TxtH, [0-markShift, 0], [0-markShift, h]);//长度文字  
   
  plate={
    models: {
      drawAbnormalShapeA30: drawAbnormalShapeA30,
      }
    };
    markers={
      models: {
        drawAbnormalShapeA30: drawAbnormalShapeA30,
        drawAbnormalShapeA30MarkR: drawAbnormalShapeA30MarkR,
        drawAbnormalShapeA30MarkH: drawAbnormalShapeA30MarkH,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default A30;